/**
 * Base path for deck images. Put deck images in public/deck/images/
 * (e.g. copy from slides/public/images when needed).
 */
const PUBLIC_URL = process.env.PUBLIC_URL || '';
export const deckImage = (path) => `${PUBLIC_URL}/deck/images${path}`;
export const deckVideo = (path) => `${PUBLIC_URL}/deck/videos${path}`;
